const EMAIL_BODY_ALLOWED_URL_PROTOCOLS = ['http', 'https', 'mailto'] as const;

export default EMAIL_BODY_ALLOWED_URL_PROTOCOLS;
